import type { AccountProps } from '@atlassian/account/nav4';
import { useSwitchAccountLink, useUser } from '#definitions/user';

/**
 * Temporary sharing between Nav3 and Nav4 for oauth-consent_nav4-migration.
 * At flag cleanup, move this prop assembly and identity-environment mapping
 * into Nav4 in Navigation/index.tsx, then delete this file with the Nav3 caller.
 */
export function useAccountProps(): AccountProps {
  const user = useUser();
  const switchAccountLink = useSwitchAccountLink(false);

  return {
    testId: 'account-menu',
    name: user?.name,
    picture: user?.picture,
    email: user?.email,
    identityEnvironment: determineIdentityEnvironment(),
    application: 'atlassian-consent-screen',
    continueUrl: switchAccountLink,
    isLoggedOut: !user,
    currentTheme: 'auto',
  };
}

function determineIdentityEnvironment(): AccountProps['identityEnvironment'] {
  switch (process.env.ENV_TYPE) {
    case 'stg':
      return 'staging';
    case 'prod':
      return 'prod';
    case 'stg-fedm':
      return 'staging-fedramp-moderate';
    case 'prod-fedm':
      return 'prod-fedramp-moderate';
    default:
      return 'dev';
  }
}
